module.exports = __webpack_public_path__ + "static/media/cvv.bd9a91da.png";